import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { BACKEND_APIS } from "@constants"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { useToast } from "@hooks"

export default function useAutoEuropeClone(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onClone = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/list`, { id })
			.then(data => {
				// Drop id + name so saving performs an insert (create), not an update.
				const { id: _id, name: _name, ...rest } = data
				autoEuropeDrawerData.value = { ...rest, name: null }
				autoEuropeOriginalData.value = null
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
				showToast.error("Error cloning AutoEurope pricing tool")
			})
	}, [id])

	return { onClone, isLoading: isLoading.value }
}